<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.promotion.title.searchPromotion" sideMenu></TopBarBg>
        <PageContent class="px-8 flex-auto" :hasPoweredBy="hasPoweredBy">
            <div class="-mt-10 my-6">
                <!-- <div>
                    <DashboardSlider ref="dashboard" :apiConfig="dashboardConfig"></DashboardSlider>
                </div> -->
                 <SearchPromotionCategoryList @onLoaded="onLoaded()"></SearchPromotionCategoryList>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
        <VBottomSheet v-model="bottomSheetSuccess" :persistent="false">
            <div class="px-6 mt-4 text-center">
                <div class="mb-4 font-semibold text-lg text-primary">
                    {{ lbl.bottomSheet.sorry }} !
                </div>
                <div>
                    <div
                        class="text-lg text-primary uppercase"
                        v-html="lbl.register.bottomSheet.txtSuccess"
                    ></div>
                    <div class="mt-6 mb-8">
                        <VBtn blocked large variant="primary">{{ lbl.register.buttons.register }}</VBtn>
                    </div>
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>
    </div>
</template>

<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import VBtn from "@/components/Button/VBtn.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"
import SearchPromotionCategoryList from "../component/SearchPromotionCategoryList.vue"

// mixin
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import PdpaMixin from "@/mixin/PdpaMixin";

// helper
import AccountHelper from "@/helper/AccountHelper"

export default {
    name: "SearchPromotionPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        VBtn,
        ModalMaster,
        VBottomSheet,
        SearchPromotionCategoryList
    },
    data: function () {
        return {
            hasPoweredBy: false,
            acceptCondition: false,
            bottomSheetSuccess: false,
            searchPromotionItems: [],
            trackingScreenName: 'searching_promotion',
        }
    },
    mounted: function () {
        this.init()
        this.tracking.screenName(this.trackingScreenName);
        this.loadingModal.show()
    },
    methods: {
        init: function () {
            let user = AccountHelper.getCacheUser()
            console.log(user)
            if (user == null) {
                // show bottom sheet
            }
        },
        onLoaded: function(){
            this.loadingModal.hide()
        }
    }
}
</script>
